var map = {
	"./img/avatar.jpg": 9323,
	"./img/back-black.png": 1418,
	"./img/checkbox-sel.png": 5513,
	"./img/checkbox-unsel.png": 5816,
	"./img/close.png": 8485,
	"./img/default.png": 3143,
	"./img/goods-detail-coupon-01.png": 6256,
	"./img/goods-detail-coupon-02.png": 7118,
	"./img/icon-arrange-asc.png": 4347,
	"./img/icon-arrange-default.png": 2167,
	"./img/icon-arrange-desc.png": 4005,
	"./img/icon-back-w.png": 2468,
	"./img/icon-close.png": 7175,
	"./img/icon-delete@2x.png": 3822,
	"./img/icon-finger.png": 5902,
	"./img/icon-goods-video.png": 974,
	"./img/icon-hot.png": 4069,
	"./img/icon-share-w.png": 9555,
	"./img/icon-video-player.png": 7385,
	"./img/icon-views.png": 4781,
	"./img/logo.png": 2384,
	"./img/more-shipping-list-1.png": 5006,
	"./img/more-shipping-list-2.png": 3931,
	"./img/more-shipping-list-3.png": 3013,
	"./img/more-shipping-list-4.png": 4507,
	"./img/no-data-v2.png": 4511,
	"./img/no-data-v3.png": 2719,
	"./img/no-data.png": 1435,
	"./img/quote-left.png": 8497,
	"./img/quote-right.png": 9016,
	"./img/share-black.png": 919,
	"./img/shop-logo/1.png": 6954,
	"./img/shop-logo/2.png": 7529,
	"./img/shop-logo/3.png": 4690,
	"./img/shop-logo/5.png": 1317,
	"./img/shop-logo/6.png": 7226,
	"./img/shop-logo/7.png": 7662,
	"./img/shop-logo/8.png": 6514,
	"./img/svg/coins.svg": 3951,
	"./img/taoke-flag-1.png": 3105,
	"./img/taoke-flag-2.png": 3062,
	"./img/taoke-flag-3.png": 5581,
	"./img/taoke-flag-4.png": 9389,
	"./img/temp-index.png": 8295,
	"./img/wx-pop.png": 2860,
	"./music/demo.mp3": 4940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5186;